import { FormEt004 } from './../../entity/forms/form-et004';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormEt004Component } from 'src/app/views/form-et004/form-et004.component';

@Component({
  selector: 'app-form-modal-confirm',
  templateUrl: './form-modal-confirm.component.html',
  styleUrls: ['./form-modal-confirm.component.scss']
})
export class FormModalConfirmComponent implements OnInit {

  valoresAlterados: any[] = [];
  public title: string;
  public valuePrev: string;
  public valueC: string;
  public parentRef: FormEt004Component;
  isAddFlow: boolean = false;

  @Output() change = new EventEmitter();


  displayedColumns: string[] = ['campo', 'valorAtual', 'valorAlterado'];


  constructor(public dialogRef: MatDialogRef<FormModalConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    this.valoresAlterados = this.data.valoresAlterados;
    this.isAddFlow = this.data.isAddFlow;
    if (this.isAddFlow) {
      this.displayedColumns = ['campo', 'valorNovo'];
    }


  }
  async closeModal(): Promise<void> {
    this.dialogRef.close({ save: false });

  }
  async saveConfirm($event: any): Promise<void> {

    // this.parentRef.saveConfirm(this.change);

    this.dialogRef.close({ save: true });

  }


}
